export default [
  {
    path: 'daftar',
    name: 'product list',
    component: () => import('@/views/app/product/list/page-list.vue'),
    meta: { title: 'Daftar Produk' },
  },
  {
    path: 'grup',
    name: 'product group list',
    component: () => import('@/views/app/product-group/list/page-list.vue'),
    meta: { title: 'Daftar Grup Produk' },
  },
  {
    path: 'stok',
    name: 'product check stock',
    component: () => import('@/views/app/product/check-stock/page-list.vue'),
    meta: { title: 'Cek Stok Produk' },
  },
  {
    path: 'kartu-stok',
    name: 'product stock card',
    component: () => import('@/views/app/product/stock-card/page-list.vue'),
    meta: { title: 'Kartu Stok Produk' },
  },
  {
    path: 'multiplier-harga',
    name: 'product price multiplier',
    component: () => import('@/views/app/product/multiplier/list/page-list.vue'),
    meta: { title: 'Daftar Multiplier Harga Produk Otomatis' },
  },
]
